export default {
  isLoginModalOpened: false
}
